import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Flash"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8.70717 22.44C8.39144 22.3068 8.20621 21.9764 8.25717 21.6375L9.62217 12.75H5.99967C5.76691 12.7563 5.54444 12.6541 5.39756 12.4734C5.25067 12.2928 5.19603 12.0541 5.24967 11.8275L7.49967 2.07753C7.58128 1.73165 7.89442 1.49053 8.24967 1.50003H15.7497C15.9766 1.49926 16.1917 1.60128 16.3347 1.77753C16.4797 1.95582 16.535 2.19077 16.4847 2.41503L15.1872 8.25003H18.7497C19.0365 8.24945 19.2985 8.41248 19.4247 8.67003C19.5341 8.91667 19.5026 9.20307 19.3422 9.42003L9.59217 22.17C9.45853 22.3681 9.23847 22.4907 8.99967 22.5C8.89931 22.4982 8.80016 22.4778 8.70717 22.44ZM13.3121 9.75003L14.8121 3.00003H8.84962L6.94462 11.25H11.3771L10.1846 18.96L17.2496 9.75003H13.3121Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Flash.vue"]]);
